import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { GlobalSeguridad } from '@seguridad';

@Injectable({
  providedIn: 'root',
})
export class ServicioResumenInformacionService {
  hijo: any;
  modelo: any;
  constructor(
    private http: HttpClient,
    private seguridadGlobal: GlobalSeguridad
  ) { }

  getServicioSigmaConsulta(sistema, idFuncion, filtro, datosPeticion): Observable<any> {
    this.seguridadGlobal.validarSesion();
    return this.http.post(
      JSON.parse(sessionStorage.getItem('webConfig'))["servicioFw"] + "/FUNSigmaConsulta/ObtenerInformacion",
      {
        sistema: sistema,
        idFuncion: idFuncion,
        filtro: filtro,
        datosPeticion: datosPeticion
      },
      //httpOptions
      { headers: new HttpHeaders({ "Content-Type": "application/json", "Content-Types": this.seguridadGlobal.atributoSesion }) }
    );
  }

  /**
  * Se envia un modelo al componente que se haya registrado como hijo
  * @author Juan David cardona
  * @date 2019-08-15.
  * @param
  * @returns
  */
  AsignarModelo(modelo) {
    this.modelo = modelo;
    if (this.hijo) {
      this.hijo.AsignarModelo(modelo);
    }
  }

  ObtenerModelo() {
    if (this.modelo != undefined)
      return this.modelo;
    return undefined;
  }



}
